/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * BaseTenMultiplication.tsx - Base Ten for multiplication.
*/

import {
  StyleSheet,
  View,
  Image,
  ViewStyle
} from 'react-native';
import { hintImages } from '../HintImages';


interface BaseTenMultiplicationProps {
  multiplier: number;
  rows: number;
  usableWidth: number;
}


const BaseTenMultiplication = ({ multiplier: multiplier, rows, usableWidth }: BaseTenMultiplicationProps): JSX.Element => {

  const rowImages = [];
  const baseTenStyle: ViewStyle[] = [styles.baseTen, {width:usableWidth}];
  
  for (let row = 0; row < rows; row++) {
    const imageSource = hintImages[`cubes${multiplier}h`].uri;
    rowImages.push(
      <View style={styles.row} key={`rows_${row}`}>
        <Image style={styles.image} source={imageSource} key={`cubes_${row}`} />
      </View>
    );
  }

  return (
    <View style={baseTenStyle} key="Base_ten_multiplication_diagram">
      {rowImages}
    </View>
  );

};

export default BaseTenMultiplication;

const styles = StyleSheet.create({
  baseTen: {
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    display: 'flex',
  },

  row: {
    justifyContent: 'center',
    alignContent: 'center',
    alignSelf: 'center',
    width: '100%',
    maxWidth: '100%',
    flex: 1,
    paddingTop: 1,

  },

  image: {
    position: 'relative',
    maxHeight: '80%',
    height: '80%',
    width: '90%',
    marginVertical: 1,
    resizeMode: 'contain',
    margin: 0,
    padding: 0,
    alignSelf: 'center'
  },

});
